<template>
    <div class="reservation">
        <div class="reservation_main">
            <Map :mapData="dataSource" :dataSourceId="dataSourceId" :dataSourceFrameNum="dataSourceFrameNum"
                :carMakerData="carMakerData" :wsCarFrameNum="wsCarFrameNum" ref="MapRef"></Map>
            <div class="reservation_main_left">
                <Table :selectData="selectData" :tableData="tableData" :showDrawer="showDrawer" :loading="loading"
                    ref="TableRef" @zoneChangeEvent="zoneChangeEvent" @tableclickRow="tableclickRow">
                </Table>
            </div>
            <div class="reservation_main_Right">
                <Drawer :showDrawer="showDrawer" :detailStatusData="detailStatusData" :carMakerData="carMakerData"
                    ref="DrawerRef" @closeEvet="closeEvet"></Drawer>
            </div>

            <!-- 模拟-版本 新增 -->
            <div class="reservation_main_icon">
                <a-popconfirm title="确认?" ok-text="是" cancel-text="否" @confirm="confirm">
                    <AppstoreOutlined />
                </a-popconfirm>
            </div>
        </div>
    </div>
</template>
<script setup>
import { ref, reactive, toRefs, watch, onBeforeMount, onMounted, onUnmounted, shallowRef } from 'vue'
import Map from '@/views/test/components/Map.vue'
import Table from '@/views/test/components/Table.vue'
import Drawer from '@/views/test/components/Drawer.vue'
import { selectZoneInfos, selectZoneDetailInfos, selectRealtimeMonitorVehicleInfos, copyTestTaskAndTrack, checkExistDemonstratingTask, operationDemonstrateTaskLocationPush } from '@/api/test/realtimeMonitor.js'
import { useRoute } from 'vue-router'
import useUserStore from "@/store/modules/user";
import { message } from 'ant-design-vue'
const userStore = useUserStore();

const route = useRoute()

let dataSource = ref([])
let tableData = ref([])
let loading = ref(false)
let MapRef = ref()
let dataSourceId = ref('')
let dataSourceFrameNum = ref('')
let showDrawer = ref(false)
let DrawerRef = ref()
let selectData = ref([])
let taskId = ref(null)
// 获取测试区域
const selectZoneInfosData = (taskId) => {
    selectZoneInfos(taskId).then(res => {
        console.log(res);
        if (res.code === 200 && res.data && res.data.length > 0) {
            selectData.value = res.data
            selectZoneDetailInfosData(res.data[0].id, route.query.id)
            selectRealtimeMonitorVehicleInfosData(res.data[0].id)
        } else {
            selectData.value = res.data
            selectZoneDetailInfosData()
            selectRealtimeMonitorVehicleInfosData()
        }
    })
}


// 获取测试区域下的全部线路
const selectZoneDetailInfosData = (id, taskId) => {
    selectZoneDetailInfos(id, taskId).then(res => {
        console.log(res);
        if (res.code === 200) {
            dataSource.value = res.data
        }
    })
}

// 实时测试车辆列表査询
const selectRealtimeMonitorVehicleInfosData = (id) => {
    selectRealtimeMonitorVehicleInfos(id).then(res => {
        console.log(res);
        if (res.code === 200) {
            tableData.value = res.data
        }
    })
}


// 存储WebSocket连接的数组
const webSocketConnections = ref([]);
const carMakerData = ref([])
const detailStatusData = ref([])
const connectWS = () => {

    tableData.value.forEach((item, index) => {
        console.log(item, '778');
        if (item.isDemonstrate !== 1) {
            functionWS(item.id, item.carFrameNum)
        } else {
            moniFunctionWS(item.id, item.carFrameNum, item.isDemonstrate)
        }

    })

};
const intervalId = ref(null);
const intervaltest1 = ref(null);
const intervaltest2 = ref(null);
const functionWS = (id, carFrameNum) => {
    if ("WebSocket" in window) {

        /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
        let $chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
        let maxPos = $chars.length;
        let randomStr = "";
        for (let i = 0; i < 32; i++) {
            randomStr += $chars.charAt(Math.floor(Math.random() * maxPos));
        }

        let tid = userStore.id + "_" + id + "_" + carFrameNum;
        // let tid = randomStr + '_' + userStore.id + "_" + id + "_" + carFrameNum;
        console.log("您的浏览器支持WebSocket");
        let url = "";
        console.log(process.env, process.env.VUE_APP_WS_URL);
        if (process.env.VUE_APP_ENV == "development") {
            console.log(window.location);
            url = process.env.VUE_APP_WS_URL + "/ws/" + tid;
            // url = "ws://" + 'gsproj.zbmec.com:5127' + '/api/test-management-provincial' + "/ws/" + tid;
        } else {
            url = "ws://" + window.location.host + "/ws/" + tid;
            //   url = window.location.origin + "/ws/" + tid;
        }

        let ws = new WebSocket(url);
        ws.lastMessageTime = 0;
        ws.carFrameNum = carFrameNum
        ws.onopen = function () {
            console.log('连接成功');
            // ws.value.send("hello");
        };
        ws.onmessage = function (e) {

            // 当收到消息时更新最后消息时间
            ws.lastMessageTime = Date.now();

            // 处理消息的其他逻辑
            let data = JSON.parse(e.data);
            // console.log(data, 'webData');
            if (data.msgType === 'TASK_CAR_MONITOR') {
                carMakerData.value.push(data.msgData)
                // console.log(carMakerData.value);
            } else if (data.msgType === 'MONITOR_DEVICE_STATUS') {
                detailStatusData.value.push(data.msgData)
                console.log(detailStatusData.value);
            }

        };
        ws.onclose = function (e) {
            console.log("close", e);
        };
        ws.onerror = function (e) { };
        webSocketConnections.value.push(ws);

    } else {
        console.log("您的浏览器不支持WebSocket");
    }
}

const onlyQfId = ref('')
const moniFunctionWS = (id, carFrameNum, isDemonstrate) => {
    if ("WebSocket" in window) {

        if (JSON.parse(sessionStorage.getItem('onlyQfId')) == null) {
            let timestamp = new Date().getTime()
            /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
            let $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
            let maxPos = $chars.length
            let randomStr = ''
            for (let i = 0; i < 32; i++) {
                randomStr += $chars.charAt(Math.floor(Math.random() * maxPos))
            }
            onlyQfId.value = randomStr + timestamp
            sessionStorage.setItem('onlyQfId', JSON.stringify(onlyQfId.value))
        }

        let tid = userStore.id + "_" + id + "_" + carFrameNum + "_" + isDemonstrate + "_" + JSON.parse(sessionStorage.getItem('onlyQfId'));
        // let tid = randomStr + '_' + userStore.id + "_" + id + "_" + carFrameNum;
        console.log("您的浏览器支持WebSocket");
        let url = "";
        console.log(process.env, process.env.VUE_APP_WS_URL);
        if (process.env.VUE_APP_ENV == "development") {
            console.log(window.location);
            url = process.env.VUE_APP_WS_URL + "/ws/" + tid;
            // url = "ws://" + 'gsproj.zbmec.com:5127' + '/api/test-management-provincial' + "/ws/" + tid;
        } else {
            url = "ws://" + window.location.host + "/ws/" + tid;
            //   url = window.location.origin + "/ws/" + tid;
        }

        let ws = new WebSocket(url);
        ws.lastMessageTime = 0;
        ws.carFrameNum = carFrameNum

        ws.onopen = async function () {
            console.log('连接成功');
            // ws.value.send("hello");
            let data = {
                "clientId": tid,
                "operationType": 1
            }
            let res = await operationDemonstrateTaskLocationPush(data)
            console.log(res, '连接123');

        };
        ws.onmessage = function (e) {

            // 当收到消息时更新最后消息时间
            ws.lastMessageTime = Date.now();

            // 处理消息的其他逻辑
            let data = JSON.parse(e.data);
            console.log(data, 'webData');
            if (data.msg === 'close') {
                ws.close();
                selectZoneInfosData(taskId.value)
            } else {
                carMakerData.value.push(data)
                // console.log(carMakerData.value);
                detailStatusData.value.push(data)

                console.log(detailStatusData.value);
            }




        };
        ws.onclose = async function (e) {
            console.log("连接关闭");
            let data = {
                "clientId": tid,
                "operationType": 0
            }
            let res = await operationDemonstrateTaskLocationPush(data)
            console.log(res, '关闭123');
        };
        ws.onerror = function (e) { };
        webSocketConnections.value.push(ws);

    } else {
        console.log("您的浏览器不支持WebSocket");
    }
}


const wsCarFrameNum = ref([])
// 定时检查所有连接
intervalId.value = setInterval(() => {
    wsCarFrameNum.value = []
    webSocketConnections.value.forEach(ws => {
        const timeSinceLastMessage = Date.now() - ws.lastMessageTime;
        if (timeSinceLastMessage > 5000) {
            // 超过5秒没有收到新消息，执行操作
            wsCarFrameNum.value.push(ws.carFrameNum)
            console.log(wsCarFrameNum.value, '111111111111111111111111');

        }
    });
    // console.log(wsCarFrameNum.value);
    console.log(213123123123);
}, 5000); // 每隔5秒检查一次

// 测试区域 切换
const zoneChangeEvent = async info => {
    clearWebSockets();
    showDrawer.value = false;
    // 清理地图上的小车
    if (MapRef.value && MapRef.value.resetCars) {
        MapRef.value.resetCars(); // 新增清理小车的方法
    }
    // 重置车辆数据
    carMakerData.value = [];
    detailStatusData.value = [];
    // 获取新数据
    await selectZoneDetailInfosData(info, route.query.id);
    await selectRealtimeMonitorVehicleInfosData(info);
    // 重新连接 WS
    setTimeout(() => {
        connectWS();
    }, 2000);
};

// 关闭 drawer
const closeEvet = info => {
    console.log(info);
    showDrawer.value = false
    dataSourceFrameNum.value = ''
    MapRef.value.resetChangeCarColor()
}

const getData = () => {
    dataSource.value = []
    loading.value = true
    setTimeout(() => {
        dataSource.value.push(
            {
                id: 3,
                palteNumber: '甘A13579',
                carType: '乘用车',
                time: '2022-10-01 09:00',
                startPlace: 'K12+200',
                testTime: '2022-10-01 17:00',
                endPlace: 'K12+500',
                type: 0,
                locationVo: {
                    "lng": "103.97882",
                    "lat": "36.166649"
                },
                lineArr: [
                    [[121.209867, 31.281978], [121.209921, 31.281987], [121.210039, 31.282074], [121.210173, 31.282171], [121.210248, 31.282207], [121.210339, 31.282249], [121.210511, 31.282171], [121.210634, 31.282093], [121.21072, 31.282033]].reverse(),
                    // .reverse(),
                ]
            },
            {
                id: 5,
                palteNumber: '甘D23450',
                carType: '乘用车',
                time: '2022-10-01 15:00',
                startPlace: 'K12+500',
                testTime: '2022-10-01 19:00',
                endPlace: 'K12+600',
                type: 0,
                locationVo: {
                    "lng": "103.973472",
                    "lat": "36.171018"
                },
                lineArr: [
                    [[121.208161, 31.281845], [121.208231, 31.28185], [121.208376, 31.281859], [121.208472, 31.281854], [121.208639, 31.281854], [121.208735, 31.281854], [121.208773, 31.281859], [121.208762, 31.281941], [121.208751, 31.28201], [121.208746, 31.282106], [121.20873, 31.282212]].reverse()
                ]
            },
        )
        loading.value = false
    }, 1200)
}



// 点击列表事件
const tableclickRow = (info) => {
    console.log(info);
    showDrawer.value = true

    dataSourceId.value = info.id
    dataSourceFrameNum.value = info.frameNum
    // MapRef.value.startTrackPlayBack(info.id)

    DrawerRef.value.startMonitor(info)
    setTimeout(() => {
        // 模拟版本
        if (DrawerRef.value.carInfo.isDemonstrate === 1) {
            DrawerRef.value.getMoniCarInfo()
        } else {
            DrawerRef.value.getCarActualVideoInfoData(info)
        }
    }, 600)


}



function removeFirst60Elements() {
    carMakerData.value.splice(0, 100)
}

function removeSecond() {
    detailStatusData.value.splice(0, 50)
}

// 模拟版本 - 新增 or 删除 接口
const addOrDelete = (val) => {
    copyTestTaskAndTrack(val).then(res => {
        if (res.code === 200) {
            if (val === 1) {
                message.success('新增成功')
                clearWebSockets();
                // 重新连接 WS
                setTimeout(() => {
                    connectWS();
                }, 2000);
                selectZoneInfosData(taskId.value)
            } else {
                message.success('删除成功')
                // clearWebSockets();
                // // 重新连接 WS
                // setTimeout(() => {
                //     connectWS();
                // }, 2000);
            }

        }
    })
}

// 模拟版本
const confirm = async () => {
    console.log(123);

    let info = await checkExistDemonstratingTask()
    console.log(info);
    if (!info.data) {
        addOrDelete(1)
    } else {
        addOrDelete(0)
    }



}


// 设置定时器每隔10秒调用一次该函数
intervaltest1.value = setInterval(removeFirst60Elements, 50000);
intervaltest2.value = setInterval(removeSecond, 50000);


onMounted(() => {
    // getData()
    selectZoneInfosData(route.query.id)
    console.log(route.query.id);
    if (route.query.id) {
        taskId.value = route.query.id
    }
    setTimeout(() => {
        connectWS()
    }, 2000)

})


// 清除所有WebSocket连接的函数
const clearWebSockets = () => {
    console.log(webSocketConnections.value, '11111111111111111');
    webSocketConnections.value.forEach(function (ws) {
        ws.close(); // 关闭每一个WebSocket连接
    });
    webSocketConnections.value = []; // 清空数组
}


onUnmounted(() => {
    console.log(111);
    clearWebSockets()
    // 当组件卸载时清除 setInterval
    if (intervalId.value) {
        clearInterval(intervalId.value);
    }
    if (intervaltest1.value) {
        clearInterval(intervaltest1.value);
    }
    if (intervaltest2.value) {
        clearInterval(intervaltest2.value);
    }

    // if (ws.value) {
    //     ws.value.close();
    // }
});
</script>
<style lang="less" scoped>
.reservation_main {
    position: relative;

    .reservation_main_left {
        position: absolute;
        top: 16px;
        left: 20px;
    }

    .reservation_main_Right {
        position: absolute;
        top: 0;
        right: 0;
    }

    .reservation_main_icon {
        position: absolute;
        bottom: 20px;
        left: 10px;
        z-index: 99;
    }
}
</style>
